export const siteContent = {
  organization: {
    name: 'Team Agua',
    social: {
      instagram: 'https://www.instagram.com/teamagua.rotterdam/',
      facebook: 'https://www.facebook.com/TA.bjj',
      youtube: 'https://youtube.com/@kenanb3328',
      linkedin: 'https://www.linkedin.com/company/agua-bjj-rotterdam/',
    },
  },
  navigation: {
    home: {
      nl: 'Home',
      en: 'Home',
    },
    schedule: {
      nl: 'Rooster',
      en: 'Schedule',
    },
    coaches: {
      nl: 'Coaches',
      en: 'Coaches',
    },
    contact: {
      nl: 'Contact',
      en: 'Contact',
    },
    signup: {
      nl: 'Word lid!',
      en: 'Become a member!',
    },
    openMenu: {
      nl: 'Menu openen',
      en: 'Open menu',
    },
    closeMenu: {
      nl: 'Menu sluiten',
      en: 'Close menu',
    },
    returnToPage: {
      nl: 'Terug naar de pagina',
      en: 'Return to the page',
    },
  },
  about: {
    heroTitle: {
      nl: 'Braziliaans Jiu-Jitsu in Rotterdam',
      en: 'Brazilian Jiu-Jitsu in Rotterdam',
    },
    title: {
      nl: 'Over ons',
      en: 'About Us',
    },
    content: {
      nl: 'Welkom bij Team Agua! Wij zijn een van de oudste verenigingen van Nederland gespecialiseerd in Brazilian Jiu-Jitsu. Naast Rotterdam hebben wij ook vestigingen in Den Haag en Amsterdam. Team Agua staat vooral bekend om een combinatie van hard trainen in een gezellige en ontspannen sfeer. Bij ons is plek voor iedereen, van beginners tot gevorderden, van recreanten tot wedstrijdvechters, en van jong tot oud.\n\nBrazilian Jiu-Jitsu vindt zijn oorsprong in het begin van de 20e eeuw in Brazilië, waar de legendarische Gracie-familie de krijgskunst ontwikkelde door de nadruk te leggen op grondgevechten en submission-technieken. De vechtsport werd wereldberoemd toen Royce Gracie in 1993 de eerste editie van de Ultimate Fighting Championship (UFC) won door al zijn tegenstanders te submitten.\n\nBij Team Agua trainen we zowel met als zonder de "gi", de traditionele Japanse vechtsportkleding die ook wel bekend is van het Judo. Brazilian Jiu-Jitsu zonder gi staat bekend als Submission Grappling en wordt ook wel "No-gi Jiu-Jitsu" genoemd. Bij deze vorm van Jiu-Jitsu zijn de pakkingen anders, waardoor meer elementen van het worstelen terugkomen en meer nadruk op beenklemmen wordt gelegd.',
      en: 'Welcome to Team Agua! We are one of the oldest associations in the Netherlands specializing in Brazilian Jiu-Jitsu. In addition to Rotterdam, we also have locations in The Hague and Amsterdam. Team Agua is best known for combining hard training with a friendly and relaxed atmosphere. Everyone is welcome with us, from beginners to advanced practitioners, from recreational athletes to competitors, and from young to old.\n\nBrazilian Jiu-Jitsu originated in the early 20th century in Brazil, where the legendary Gracie family developed the martial art by emphasizing ground fighting and submission techniques. The sport became world-famous when Royce Gracie won the first edition of the Ultimate Fighting Championship (UFC) in 1993 by submitting all of his opponents.\n\nAt Team Agua, we train both with and without the "gi", the traditional Japanese martial arts uniform also known from judo. Brazilian Jiu-Jitsu without the gi is known as Submission Grappling and is often referred to as "No-Gi Jiu-Jitsu". In this form of Jiu-Jitsu, the grips are different, which brings in more elements of wrestling and places greater emphasis on leg locks.',
    },
    mobilePreview: {
      nl: 'Welkom bij Team Agua! Wij zijn een van de oudste verenigingen van Nederland gespecialiseerd in Brazilian Jiu-Jitsu',
      en: 'Welcome to Team Agua! We are one of the oldest associations in the Netherlands specializing in Brazilian Jiu-Jitsu',
    },
    readMore: {
      nl: 'Lees meer',
      en: 'Read more',
    },
    readLess: {
      nl: 'Lees minder',
      en: 'Read less',
    },
  },
  instructors: {
    defaultImage: {
      src: '/images/optimized/default-instructor-640.webp',
      smallSrc: '/images/optimized/default-instructor-320.webp',
      srcSet: '/images/optimized/default-instructor-320.webp 320w, /images/optimized/default-instructor-640.webp 640w',
    },
    labels: {
      followOnInstagram: {
        nl: 'Volg op Instagram',
        en: 'Follow on Instagram',
      },
    },
    items: [
      {
        _id: 'kenan-bajramovic',
        name: 'Kenan Bajramovic',
        image: {
          src: '/images/optimized/instructor-kenan-bajramovic-640.webp',
          smallSrc: '/images/optimized/instructor-kenan-bajramovic-320.webp',
          srcSet: '/images/optimized/instructor-kenan-bajramovic-320.webp 320w, /images/optimized/instructor-kenan-bajramovic-640.webp 640w',
        },
        instagramUrl: 'https://www.instagram.com/Kiggenn78',
        bio: {
          en: '<li>Head coach of Team Agua Rotterdam</li>\n<li>3rd degree black belt under Professor Augusto Ferrari</li>\n<li>Competition experience at international level</li>\n<li>20 years of experience</li>',
          nl: '<li>⁠Hoofdtrainer van Team Agua Rotterdam</li>\n<li>⁠3e graad zwarte band onder Professor Augusto Ferrari</li>\n<li>⁠Wedstrijdervaring op internationaal niveau</li>\n<li>⁠20 jaar ervaring</li>',
        },
        order: 1,
      },
      {
        _id: 'bart-van-der-drift',
        name: 'Bart van der Drift',
        image: {
          src: '/images/optimized/instructor-bart-van-der-drift-640.webp',
          smallSrc: '/images/optimized/instructor-bart-van-der-drift-320.webp',
          srcSet: '/images/optimized/instructor-bart-van-der-drift-320.webp 320w, /images/optimized/instructor-bart-van-der-drift-640.webp 640w',
        },
        instagramUrl: 'https://www.instagram.com/bartvddrift',
        bio: {
          en: '<li>Coach of Team Agua Rotterdam</li>\n<li>1st degree black belt under Professor Augusto Ferrari</li>\n<li>Competition experience at the national level</li>\n<li>15 years of experience</li>',
          nl: '<li>⁠Trainer van Team Agua Rotterdam</li>\n<li>⁠1e graad zwarte band onder Professor Augusto Ferrari</li>\n<li>⁠Wedstrijdervaring op nationaal niveau</li>\n<li>⁠15 jaar ervaring</li>',
        },
        order: 2,
      },
      {
        _id: 'mylan-may',
        name: 'Mylan May',
        image: {
          src: '/images/optimized/instructor-mylan-may-640.webp',
          smallSrc: '/images/optimized/instructor-mylan-may-320.webp',
          srcSet: '/images/optimized/instructor-mylan-may-320.webp 320w, /images/optimized/instructor-mylan-may-640.webp 640w',
        },
        instagramUrl: 'https://www.instagram.com/mylanmmm',
        bio: {
          en: '<li>Coach of Team Agua Rotterdam</li>\n<li>1st degree black belt under Professor Augusto Ferrari</li>\n<li>Competition experience at the national level</li>\n<li>15 years of experience</li>',
          nl: '<li>⁠Trainer van Team Agua Rotterdam</li>\n<li>⁠1e graad zwarte band onder Professor Augusto Ferrari</li>\n<li>⁠Wedstrijdervaring op nationaal niveau</li>\n<li>⁠15 jaar ervaring</li>',
        },
        order: 3,
      },
      {
        _id: 'martin-sang-a-jong',
        name: 'Martin Sang-A-Jong',
        image: null,
        instagramUrl: 'https://www.instagram.com/maxepijn/',
        bio: {
          en: '<li>Coach of Team Agua Rotterdam</li>\n<li>Black belt under Professor Augusto Ferrari</li>\n<li>Competition experience at  international level</li>\n<li>12 years of experience</li>',
          nl: '<li>⁠Trainer van Team Agua Rotterdam</li>\n<li>⁠1e graad zwarte band onder Professor Augusto Ferrari</li>\n<li>⁠Wedstrijdervaring op nationaal niveau</li>\n<li>⁠15 jaar ervaring</li>',
        },
        order: 4,
      },
    ],
  },
  contact: {
    intro: {
      nl: 'Heb je vragen over onze lessen of wil je een proefles inplannen?\nWe horen graag van je! Neem contact op via een van de onderstaande methoden.',
      en: "Have questions about our classes or want to schedule a trial session?\nWe'd love to hear from you! Reach out through any of the methods below.",
    },
    formTitle: {
      nl: 'Stuur ons een bericht',
      en: 'Send us a message',
    },
    phoneLabel: {
      nl: 'Bel ons',
      en: 'Call us',
    },
    mailLabel: {
      nl: 'E-mail',
      en: 'Email',
    },
    locationLabel: {
      nl: 'Bezoek ons',
      en: 'Visit us',
    },
    nameLabel: {
      nl: 'Naam',
      en: 'Name',
    },
    messageLabel: {
      nl: 'Bericht',
      en: 'Message',
    },
    sendMessage: {
      nl: 'Bericht versturen',
      en: 'Send message',
    },
    sending: {
      nl: 'Verzenden...',
      en: 'Sending...',
    },
    successMessage: {
      nl: 'Bedankt voor je bericht! We nemen snel contact met je op.',
      en: 'Thank you for your message! We will get back to you soon.',
    },
    errorMessage: {
      nl: 'Het verzenden van het bericht is mislukt. Probeer het opnieuw of neem direct contact met ons op.',
      en: 'Failed to send message. Please try again or contact us directly.',
    },
    phone: '+31 6 3613 7108',
    location: 'Schiedamsevest 188, 3011 BH Rotterdam, Netherlands',
  },
};

export const getLocalizedValue = (value, language) => {
  if (typeof value === 'string') return value;
  return value?.[language] || value?.nl || value?.en || '';
};
